export function withAuthorizationToken(token: string | undefined, requestInit: RequestInit = {}): RequestInit {
  if (!token) {
    return requestInit;
  }

  return {
    ...requestInit,
    headers: {
      ...requestInit.headers,
      Authorization: `Bearer ${token}`,
    },
  };
}
